'use client';

import { useState } from 'react';

import { Box, Container } from '@mui/material';

import { CustomerElearning } from 'src/sections/landing/components/customer-elearning';
import { CenterRegisterForm } from 'src/sections/landing/components/center-register-form';
import { TestimonialElearning } from 'src/sections/landing/components/testimonial-elearning';

import { IntroWithdrawal } from '../components/intro-withdrawal';
import { DetailWithdrawalFunction } from '../components/detail-withdrawal-function';
import { StartWithCenterUpWithdrawal } from '../components/start-with-center-up-withdrawal';

export const WithdrawalView = () => {
  const [openDemo, setOpenDemo] = useState<boolean>(false);
  return (
    <Box sx={{ overflowX: 'hidden', width: 1 }}>
      <Container>
        <IntroWithdrawal setOpenDemoForm={() => setOpenDemo(true)} />
        <CustomerElearning />
        <DetailWithdrawalFunction />
      </Container>
      <TestimonialElearning />
      <Container>
        <StartWithCenterUpWithdrawal setOpenDemoForm={() => setOpenDemo(true)} />
      </Container>
      {openDemo && <CenterRegisterForm open={openDemo} onClose={() => setOpenDemo(false)} />}
    </Box>
  );
};
